<template>
  <v-main class="pa-0 fill-height">
    <div id="mapa">
      <gmap-map
        ref="gmap"
        :center="center"
        :zoom="zoom"
        @zoom_changed="onZoomChanged"
        style="width: 100%; height: 100%"
        :options="option"
      >
        <template v-if="zoom <= vehiclesClusterMaxZoom">
          <GmapCluster :ignoreHidden="false" :minimumClusterSize="2" :gridSize="60" :maxZoom="vehiclesClusterMaxZoom">
            <div v-for="vehicle in vehicles" :key="vehicle.key">
              <gmap-marker
                v-if="vehicle.visible === true && travelTrip == vehicle.service"
                :position="vehicle.coor"
                :icon="rotateImageVehicle(vehicle.angule)"
                :optimized="true"
                :animation="0"
                :draggable="false"
                @mouseover="openWindow(vehicle)"
                @mouseout="closeWindow(vehicle)"
              >
                <gmap-info-window :opened="vehicle.dialog">
                  <div class="vehicleModal">
                    <b>Número de unidad:</b> {{ vehicle.noVehicle }}
                  </div>
                </gmap-info-window>
              </gmap-marker>
            </div>
          </GmapCluster>
        </template>
        <template v-else>
          <div v-for="vehicle in vehicles" :key="vehicle.key">
            <gmap-marker
              v-if="vehicle.visible === true && travelTrip == vehicle.service"
              :position="vehicle.coor"
              :icon="rotateImageVehicle(vehicle.angule)"
              :optimized="true"
              :animation="0"
              :draggable="false"
              @mouseover="openWindow(vehicle)"
              @mouseout="closeWindow(vehicle)"
            >
              <gmap-info-window :opened="vehicle.dialog">
                <div class="vehicleModal">
                  <b>Número de unidad:</b> {{ vehicle.noVehicle }}
                </div>
              </gmap-info-window>
            </gmap-marker>
          </div>
        </template>
  
        <div v-if="!isReadingMarkers">
          <GmapCluster :ignoreHidden="false" :position="center" :zoomOnClick="true" :clickable="true" :animation="2">
            <div v-for="marker in markers" :key="marker.key || (marker.idruta_externo + '-' + marker.stopName)">
              <gmap-marker
                v-if="marker.visible === true"
                :position="marker.coor"
                :icon="icon"
                :optimized="true"
                :animation="0"
                :draggable="false"
                @mouseover="openWindow(marker)"
                @mouseout="closeWindow(marker)"
              >
                <gmap-info-window :opened="marker.dialog">
                  <div class="dialog">
                    {{ marker.stopName }}
                  </div>
                </gmap-info-window>
              </gmap-marker>
            </div>
          </GmapCluster>
        </div>

        <gmap-polyline
          v-for="(p, i) in lineColor"
          :key="p.key || (p.idruta_externo + '-poly')"
          :path="lineColor[i].path"
          :options="{ strokeColor: lineColor[i].color, strokeOpacity: lineColor[i].opacityLine }"
        />
      </gmap-map>

      <!-- Controles del mapa -->
      <div id="searchClients" style="margin-left: 10px">
        <v-card style="margin-top: 10px" max-width="400">
          <v-row no-gutters dense class="ps-2 pe-2">
            <v-col cols="8" sm="8" md="8">
              <v-autocomplete
                v-model="clientSearch"
                :items="clientItem"
                label="Clientes"
                prepend-icon="mdi-account-group"
                @change="consult()"
              />
            </v-col>
            <v-col cols="4" sm="4" md="4" class="d-flex align-self-center justify-center">
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!clientSearch"
                dense
                color="pinkKonect"
                class="mx-2"
                elevation="0"
                @click="consult()"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <div id="updateInfo">
        <v-progress-circular v-if="loading" indeterminate color="primary" />
        <span v-else class="caption">Ultima actualización: {{ lastUpdate }} </span>
        <v-tooltip top v-if="!loading">
          <template #activator="{ on, attrs }">
            <v-icon color="blueKonect" dark v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
          </template>
          <span>La actualización es automática</span>
        </v-tooltip>
      </div>

      <div id="service" style="margin-right: 10px">
        <v-card style="margin-top: 10px" max-width="400">
          <v-row no-gutters dense class="ps-2 pe-2">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="travelTrip"
                :items="travelInfo"
                label="Tipo de servicio"
                prepend-icon="mdi-routes"
                @change="consult()"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>

      <div id="busses" style="margin-left: 10px; margin-inline-end: 0px; writing-mode: vertical-tb">
        <v-card max-width="350" style="margin-top: 10px" v-if="clientSearch">
          <v-card-title>
            <span class="headline">Rutas</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="viewDetails()" text>{{ messageDetail }}</v-btn>
          </v-card-title>

          <div v-if="viewDetail === 0">
            <v-btn color="primary" @click="hidden()" text>Ocultar</v-btn>
            <v-btn color="primary" @click="noHidden()" text>Mostrar</v-btn>

            <v-card-text style="max-height: 300px" class="scroll">
              <div v-for="(cData, n) in clientsData" :key="cData.name">
                {{ clientsData[n].name }}
                <span v-if="travelTrip == 'M'">(Mete)</span>
                <span v-if="travelTrip == 'S'">(Saca)</span>
                <span v-if="travelTrip == ''">(Mete y saca)</span>

                <div v-for="(p, i) in clientsData[n].detail" :key="p.idruta_externo">
                  <v-btn
                    v-if="clientsData[n].detail[i].info === true"
                    icon
                    color="pinkKonect"
                    @click="viewUnit(clientsData[n].detail[i])"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    icon
                    color="blueKonect"
                    @click="viewUnit(clientsData[n].detail[i])"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>

                  <v-btn icon @click="entryOpacity(clientsData[n].detail[i])">
                    <v-icon v-if="clientsData[n].detail[i].visible" :color="clientsData[n].detail[i].color">mdi-car</v-icon>
                    <v-icon v-else>mdi-car-off</v-icon>
                  </v-btn>

                  {{ clientsData[n].detail[i].idruta }}
                  {{ clientsData[n].detail[i].name }}

                  <div v-for="(info, inf) in vehicles" :key="inf">
                    <span v-if="clientsData[n].detail[i].info === false">
                      <span v-if="clientsData[n].detail[i].idruta_externo == vehicles[inf].idruta_externo">
                        <v-btn icon @click="entryOpacity(clientsData[n].detail[i])">
                          <v-icon v-if="clientsData[n].detail[i].visible" :color="clientsData[n].detail[i].color">mdi-bus</v-icon>
                          <v-icon v-else>mdi-bus</v-icon>
                        </v-btn>
                        {{ vehicles[inf].noVehicle }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </div>
    </div>

    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>

    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
      {{ errorList[codeError] }}
      {{ '\n\n' + this.codeError }}
    </v-snackbar>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import services from '@/utils/services'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
import errorList from '@/utils/errorsList'

export default {
  name: 'Maps',
  data: () => ({
    routes: [
      { text: 'Inicio', disabled: false, href: 'Home', icon: 'mdi-home', color: 'blueKonect' },
      { text: 'Mapas', disabled: false, href: 'mapaClientes', icon: 'mdi-map', color: 'blueKonect' },
      { text: 'Mapas de clientes', disabled: true, href: 'mapaClientes', icon: 'mdi-map-search' }
    ],
    errorList,
    items: [],
    lineColor: [],
    simbolos: '0123456789ABCDEF',
    newColor: '',
    itemsAux: [],
    travelInfo: [
      { text: 'Mete', value: 'M' },
      { text: 'Saca', value: 'S' }
    ],
    travelTrip: '',
    locationBus: [],
    infoTravel: '',
    stopsData: false,
    dataLine: [],
    clientsData: [],
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',
    codeError: '',
    viewDetail: 1,
    messageDetail: 'Ver',
    center: { lat: 25.689665, lng: -100.310619 },
    option: {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false
    },
    zoom: 13,
    vehiclesClusterMaxZoom: 12, 
    window_open: false,
    icon: { url: require('@/assets/marker.png') },
    bus: { url: require('@/assets/bus.png'), scaledSize: null },
    locate: null,
    clientItem: [],
    clientSearch: '',
    timeCoor: 0,
    lastUpdate: moment().format('h:mm:ss a'),
    markers: [],
    vehicles: [],    
    vehiclesIndex: new Map(), 
    path: [],
    path2: [],
    aux: [],
    coorAux: [],
    colors: ['#ff00e6', '#ff0000', '#00a600', '#004cff', '#ff8400', '#3c00ff', '#0077ff', '#ff00a6', '#000'],

    hiddenRouteIds: new Set()
  }),
  computed: {
    google: gmapApi,
    isReading() {
      return services.check(1, this.$route.path)
    },
    isReadingTracking() {
      return services.check(1, '/client/tracking')
    },
    isReadingMarkers() {
      return services.check(1, '/client/markers')
    }
  },
  mounted() {
    if (this.isReading) {
      this.$refs.gmap.$mapPromise.then((map) => {
        const searchClients = document.getElementById('searchClients')
        searchClients.index = 1
        map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(searchClients)

        const service = document.getElementById('service')
        service.index = 1
        map.controls[this.google.maps.ControlPosition.RIGHT_TOP].push(service)

        const updateInfo = document.getElementById('updateInfo')
        updateInfo.index = 1
        map.controls[this.google.maps.ControlPosition.BOTTOM_CENTER].push(updateInfo)

        const busses = document.getElementById('busses')
        busses.index = 1
        map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(busses)
      })

      this.$gmapApiPromiseLazy().then(() => {
        this.bus.scaledSize = new this.google.maps.Size(50, 50)
      })
      this.travelTrip = this.travelInfo[0].value
      this.refresh()
    } else {
      this.$router.push('/client/reporteUsuarios')
    }
  },
  destroyed() {
    clearInterval(this.locate)
  },
  methods: {
    onZoomChanged() {
      const map = this.$refs.gmap && this.$refs.gmap.$mapObject
      if (map) this.zoom = map.getZoom()
    },

    isRouteHidden(id) { return this.hiddenRouteIds.has(id) },
    hideRouteId(id) { this.hiddenRouteIds.add(id) },
    showRouteId(id) { this.hiddenRouteIds.delete(id) },

    refresh() {
      this.loading = true
      services
        .ws('get', 'clients')
        .then((res) => {
          this.itemsAux = res.data
          this.clientItem = this.itemsAux.map((c) => ({
            text: c.nombre_comercial,
            value: c.idcliente_externo
          }))
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response?.data?.message
        })
        .finally(() => {
          this.loading = false
        })
    },

    viewDetails() {
      if (this.viewDetail === 1) {
        this.viewDetail = 0
        this.messageDetail = 'Ocultar'
      } else {
        this.viewDetail = 1
        this.messageDetail = 'Ver'
      }
    },

    viewUnit(view) { view.info = !view.info },

    rotateImageVehicle() {
      const data = require('@/assets/busMarker.png')
      return { url: data }
    },

    openWindow(obj) { obj.dialog = true },
    closeWindow(obj) { obj.dialog = false },

    entryOpacity(route) {
      const id = route.idruta_externo
      route.visible = !route.visible
      if (!route.visible) this.hideRouteId(id)
      else this.showRouteId(id)

      for (const lc of this.lineColor) if (lc.idruta_externo === id) lc.opacityLine = route.visible ? 1 : 0
      for (const m of this.markers) if (m.idruta_externo === id) m.visible = route.visible
      for (const v of this.vehicles) if (v.idruta_externo === id) v.visible = route.visible
    },

    hidden() {
      this.hiddenRouteIds = new Set(this.lineColor.map((r) => r.idruta_externo))
      for (const lc of this.lineColor) { lc.opacityLine = 0; lc.visible = false }
      for (const m of this.markers) m.visible = false
      for (const v of this.vehicles) v.visible = false
    },

    noHidden() {
      this.hiddenRouteIds = new Set()
      for (const lc of this.lineColor) { lc.opacityLine = 1; lc.visible = true }
      for (const m of this.markers) m.visible = true
      for (const v of this.vehicles) v.visible = true
    },

    outOpacity() { for (const lc of this.lineColor) lc.opacityLine = 1 },

    consult() {
      if (!this.clientSearch) return

      this.hiddenRouteIds = new Set()
      this.newLine = 0
      this.loading = true
      this.path = []
      this.path2 = []
      this.coorAux = []
      this.markers = []
      this.vehicles = []
      this.vehiclesIndex = new Map()
      this.clientsData = []

      const data = { data: { idcliente_externo: this.clientSearch } }
      services
        .ws('post', 'maps', data)
        .then((res) => {
          this.items = res.data

          for (let i = 0; i < this.items.length; i++) {
            for (let j = 0; j < this.items[i].cliente.length; j++) {
              this.lineColor = []
              this.path = []

              const rutas = this.items[i].cliente[j].cliente.rutas
              const clienteNombre = this.items[i].cliente[j].cliente.nombre_comercial

              for (let k = 0; k < rutas.length; k++) {
                const ruta = rutas[k]
                if (this.travelTrip === ruta.tipo_servicio || this.travelTrip === '') {
                  for (let c = 0; c < 6; c++) this.newColor += this.simbolos[Math.floor(Math.random() * 16)]
                  this.lineColor.push({
                    idruta: ruta.idruta,
                    idruta_externo: ruta.idruta_externo,
                    color: this.colors[this.getRandomInt(9)],
                    opacityLine: 1,
                    client: clienteNombre,
                    name: ruta.nombre_ruta,
                    info: false,
                    visible: true,
                    path: []
                  })

                  const poly = []
                  for (let l = 0; l < ruta.georuta.coordinates.length; l++) {
                    poly.push({
                      lat: ruta.georuta.coordinates[l][1],
                      lng: ruta.georuta.coordinates[l][0],
                      color: '#' + this.newColor
                    })
                  }
                  this.newColor = ''
                  this.lineColor[this.lineColor.length - 1].path = Object.freeze(poly.slice())

                  for (let l = 0; l < ruta.paradas.length; l++) {
                    const parada = ruta.paradas[l]
                    this.markers.push({
                      idruta_externo: ruta.idruta_externo,
                      visible: true,
                      routeName: ruta.nombre_ruta,
                      stopName: parada.nombre_parada,
                      dialog: false,
                      coor: {
                        lat: parada.coordenadas !== null ? parada.coordenadas.coordinates[1] : 0,
                        lng: parada.coordenadas !== null ? parada.coordenadas.coordinates[0] : 0
                      }
                    })
                  }
                }
              }

              this.clientsData.push({
                name: clienteNombre,
                detail: this.lineColor.sort((a, b) => a.name.localeCompare(b.name))
              })
            }
          }
          this.success = true
          this.msgSuccess = 'Rutas obtenidas con exito'
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response?.data?.code
        })
        .finally(() => {
          if (!this.isReadingTracking) {
            this.updateVehicle()
            this.timeData()
          } else {
            this.loading = false
          }
        })
    },

    timeData() {
      clearInterval(this.locate)
      this.locate = setInterval(() => { this.updateVehicle() }, 5000)
    },

    vehicleKey(b) { return `${b.idruta_externo}#${b.numero_economico}` },

    updateVehicle() {
      if (this.isReadingTracking || !this.clientSearch) return
      const data = { data: { idcliente_externo: this.clientSearch } }

      services
        .ws('post', 'tracking', data)
        .then((res) => {
          if (typeof res.ok !== 'undefined' && !res.ok) {
            this.error = true
            this.codeError = res.data?.message
            return
          }

          const incoming = res.data || []
          const seen = new Set()

          for (const b of incoming) {
            const key = this.vehicleKey(b)
            seen.add(key)

            const hidden = this.isRouteHidden(b.idruta_externo)

            if (this.vehiclesIndex.has(key)) {
              const idx = this.vehiclesIndex.get(key)
              const v = this.vehicles[idx]
              v.coor.lat = b.posicion.coordinates[1]
              v.coor.lng = b.posicion.coordinates[0]
              v.angule = b.direccion
              v.service = b.tipo_servicio
              v.visible = !hidden
            } else {
              const v = {
                key,
                noVehicle: b.numero_economico,
                dialog: false,
                angule: b.direccion,
                visible: !hidden,
                idruta_externo: b.idruta_externo,
                service: b.tipo_servicio,
                coor: { lat: b.posicion.coordinates[1], lng: b.posicion.coordinates[0] }
              }
              this.vehiclesIndex.set(key, this.vehicles.length)
              this.vehicles.push(v)
            }
          }
          for (let i = this.vehicles.length - 1; i >= 0; i--) {
            const vk = this.vehicles[i].key
            if (!seen.has(vk)) {
              this.vehicles.splice(i, 1)
              this.vehiclesIndex.delete(vk)
              for (let j = i; j < this.vehicles.length; j++) {
                this.vehiclesIndex.set(this.vehicles[j].key, j)
              }
            }
          }
        })
        .catch((error) => {
          this.error = true
          this.codeError = error.response?.data?.message
        })
        .finally(() => {
          this.lastUpdate = moment().format('h:mm:ss a')
          this.loading = false
        })
    },

    getRandomInt(max) { return Math.floor(Math.random() * max) }
  }
}
</script>

<style scoped>
html, body, #app, .v-application, .v-application--wrap {
  height: 100%;
  min-height: 100dvh;   
  margin: 0;
  overflow: hidden;     
}

#mapa {
  width: 100%;
  height: 100dvh;   
  position: relative;
}

.v-main { padding: 0 !important; }

#mapa .vue-map-container,
#mapa .gmap-container {
  position: absolute;
  inset: 0;
}

.vehicleModal { align-content: center !important; }
.scroll { overflow-y: scroll !important; }
</style>
